const PopoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2.01855 12.4817V3.5188C2.01855 2.69037 2.69013 2.0188 3.51855 2.0188H6.90332C7.17946 2.0188 7.40332 2.24266 7.40332 2.5188C7.40332 2.79494 7.17946 3.0188 6.90332 3.0188H3.51855C3.24241 3.0188 3.01855 3.24266 3.01855 3.5188V12.4817C3.01882 12.7576 3.24258 12.9817 3.51855 12.9817H12.4814C12.7572 12.9814 12.9812 12.7574 12.9814 12.4817V9.09595C12.9816 8.81994 13.2054 8.59595 13.4814 8.59595C13.7573 8.59621 13.9813 8.8201 13.9814 9.09595V12.4817C13.9812 13.3097 13.3095 13.9814 12.4814 13.9817H3.51855C2.69029 13.9817 2.01882 13.3099 2.01855 12.4817Z"
      fill="currentColor"
    />
    <path
      d="M8.35327 8.35352C8.15801 8.54878 7.8415 8.54878 7.64624 8.35352C7.45098 8.15825 7.45098 7.84175 7.64624 7.64648L13.2927 2H9.85718C9.58104 2 9.35718 1.77614 9.35718 1.5C9.35718 1.22386 9.58104 1 9.85718 1H13.4998C14.3282 1 14.9998 1.67157 14.9998 2.5V6.14258C14.9998 6.41872 14.7759 6.64258 14.4998 6.64258C14.2236 6.64258 13.9998 6.41872 13.9998 6.14258V2.70703L8.35327 8.35352Z"
      fill="currentColor"
    />
  </svg>
);

export default PopoutIcon;
